<!-- <app-loading *ngIf="isLoading"></app-loading> -->
<section class="login-section"   [style.background]="'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(/assets/images/login/login-bg.jpg)'"
[style.backgroundSize]="'cover'"
[style.backgroundPosition]="'center'">

    <div class="header-section d-flex justify-content-between align-items-center">
        <div class="logo-sec">
            <a [routerLink]="['/']" class="login-logo-link" aria-label="YokaStar — Accueil">
                <div class="login-logo-wrap">
                    <img src="assets/images/logo/logo.png" alt="YokaStar" class="login-logo-img img-fluid">
                </div>
            </a>
        </div>
        <div class="right-links">
            <ul>
                <li>
                    <a [routerLink]="['/contact']">Contact</a>
                </li>
                <li>
                    <a class="explore-btn" [routerLink]="['/']" [queryParamsHandling]="'merge'" [routerLinkActive]="'active'" [skipLocationChange]="true">
                        Explorez
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="container">
        <div class="row">
            
            <div class="col-xl-6 col-lg-7 col-md-10 col-12 m-auto">
                <div class="login-form">
                    <div>
                        <div class="login-title">
                            <h2>Connexion</h2>
                        </div>
                        <div class="login-discription">
                            <!-- <h3>Bienvenue à YokaStar </h3> -->
                            <!-- <h4>Bienvenue sur YokaStar, connectez-vous à votre compte pour accéder à votre espace.</h4> -->
                            @if (errorMessage) {
                                <div class="alert alert-danger">
                                    <p style="color: red;">{{errorMessage}}</p>
                                </div>
                               
                            }
                        </div>
                        <div class="form-sec">
                            <div>
                                <form class="theme-form" *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="handleSubmitLogin($event)">
                                    <div class="form-group">
                                        <label for="exampleInputEmail1">Email ou nom d'utilisateur <span class="required">*</span></label>
                                        <input type="text" formControlName="email" autocomplete="off" class="form-control" id="exampleInputEmail1"
                                            placeholder="Entrez votre email ou nom d'utilisateur" name="email">
                                        <app-feather-icon [icons]="'user'"
                                            [class]="'input-icon iw-20 ih-20'"></app-feather-icon>
                                    </div>
                                    <div class="form-error" *ngIf="isLoginSubmited && loginFormControls!['email'].errors">
                                        <div class="form-error-item" *ngIf="isLoginSubmited && loginFormControls!['email'].errors['required']">
                                            L'email ou nom d'utilisateur est obligatoire
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="exampleInputPassword1">Mot de passe <span class="required">*</span></label>
                                        <div class="password-input-group">
                                            <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" id="exampleInputPassword1"
                                                placeholder="Mot de passe" name="password">
                                                @if(showPassword) {
                                                    <app-feather-icon [icons]="'eye-off'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordVisibility()" style="cursor: pointer;"></app-feather-icon>
                                                } @else {
                                                    <app-feather-icon [icons]="'eye'" [class]="'input-icon iw-20 ih-20'" (click)="togglePasswordVisibility()" style="cursor: pointer;"></app-feather-icon>
                                                }
                                        </div>
                                    </div>
                                    <div class="form-error" *ngIf="isLoginSubmited && loginFormControls!['password'].errors">
                                        <div class="form-error-item" *ngIf="isLoginSubmited && loginFormControls!['password'].errors['required']">
                                            Le mot de passe est obligatoire
                                        </div>
                                        <div class="form-error-item" *ngIf="isLoginSubmited && loginFormControls!['password'].errors['minLength']">
                                            Mot de passe trop court
                                        </div>
                                    </div>
                                    <div class="bottom-sec">
                                        <div class="form-check checkbox_animated">
                                            <input type="checkbox" class="form-check-input" id="exampleCheck1">
                                            <label class="form-check-label" for="exampleCheck1">Se souvenir de moi</label>
                                        </div>
                                        <a href="javascript:void(0)" class="ms-auto forget-password" [routerLink]="['/forgot-password']">Mot de passe oublié ?</a>
                                    </div>
                                    <div class="btn-section">
                                        <button type="submit" class="btn btn-solid btn-md" [disabled]="isLoading">
                                            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span *ngIf="!isLoading">Se connecter</span>
                                        </button>
                                        <a type="button" class="btn btn-solid btn-md ms-auto" (click)="choosePhoto()">Créer un compte</a>
                                        <!-- <button (click)="choosePhoto()"></button> -->
                                    </div>  
                                </form>

                                <div class="connect-with">
                                
                                    <h6 class="my-3 text-center">
                                        <span>OU Connectez-vous avec</span>
                                    </h6>
                                
                                    <!-- bouton WEB -->
                                    <div class="social-login d-flex justify-content-center my-3" *ngIf="!isMobile">
                                        <div id="googleButton"></div>
                                    </div>
                                
                                    <!-- bouton MOBILE -->
                                    <div class="d-flex justify-content-center my-3" *ngIf="isMobile">
                                
                                        <button class="btn btn-light border d-flex align-items-center gap-2"
                                                (click)="loginWithGoogleMobile()">
                                
                                            <img src="assets/google.png" width="20">
                                            Continuer avec Google
                                
                                        </button>
                                
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-5 login-welcome-column">
                <div class="login-welcome d-none d-lg-block">
                    <div>
                        <h1 style="text-align: left;margin-bottom: 50px;">Bienvenue à YokaStar</h1>
                    </div>
                </div>
                <div class="how-work">
                    <div class="media">
                        <app-feather-icon [icons]="'play-circle'" (click)="commonService.videoPlay(commonService.urls)" style="cursor: pointer;"></app-feather-icon>
                        <div class="media-body">
                            <h2>Comment ça marche ?</h2>
                            <p>
                                YokaStar est une plateforme qui connecte les fans à leurs célébrités préférées en leur permettant de commander des vidéos de dédicace personnalisées. Les fans envoient une demande, la célébrité enregistre la vidéo et l'envoie en échange d'un paiement sécurisé. Créez des souvenirs uniques avec YokaStar !
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <router-outlet></router-outlet> -->
<!-- <notification></notification> -->
